// src/features/owner/sections/users/SuspendedUsersSection.tsx
import { useOwnerUsers } from '@/hooks';
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';
import type { OwnerUserRow } from '@/core/models';

export function SuspendedUsersSection() {
  const { data, loading, error, refetch } = useOwnerUsers('', '', 'suspended');
  const action = useOwnerAction();

  const columns: Column<OwnerUserRow>[] = [
    {
      key: 'handle',
      header: 'User',
      sortBy: (r) => r.handle,
      render: (r) => `${r.name} ${r.handle}`,
    },
    {
      key: 'actions',
      header: '',
      render: (r) => (
        <Button
          variant="ghost"
          onClick={async () => {
            await action.unsuspend(r.id);
            refetch();
          }}
        >
          Lift suspension
        </Button>
      ),
    },
  ];

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  return (
    <OwnerPanel title="Suspended users">
      <DataTable<OwnerUserRow>
        columns={columns}
        rows={data ?? []}
        rowKey={(r) => r.id}
        emptyIcon="user-x"
        emptyMessage={error ?? 'No suspended users'}
      />
    </OwnerPanel>
  );
}
